// source: pbtypes/gen/scan_planner/long_range_explore_request.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_scan_output_scan_coverage_parameters_pb = require('../../../pbtypes/gen/scan_output/scan_coverage_parameters_pb.js');
goog.object.extend(proto, pbtypes_gen_scan_output_scan_coverage_parameters_pb);
var pbtypes_gen_scan_planner_long_range_explore_replan_state_pb = require('../../../pbtypes/gen/scan_planner/long_range_explore_replan_state_pb.js');
goog.object.extend(proto, pbtypes_gen_scan_planner_long_range_explore_replan_state_pb);
goog.exportSymbol('proto.scan_planner.LongRangeExploreRequest', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.scan_planner.LongRangeExploreRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.scan_planner.LongRangeExploreRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.scan_planner.LongRangeExploreRequest.displayName = 'proto.scan_planner.LongRangeExploreRequest';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.scan_planner.LongRangeExploreRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.scan_planner.LongRangeExploreRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.scan_planner.LongRangeExploreRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scan_planner.LongRangeExploreRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
numMeshPoints: jspb.Message.getFieldWithDefault(msg, 1, 0),
scanCoverageParameters: (f = msg.getScanCoverageParameters()) && pbtypes_gen_scan_output_scan_coverage_parameters_pb.ScanCoverageParameters.toObject(includeInstance, f),
replanState: (f = msg.getReplanState()) && pbtypes_gen_scan_planner_long_range_explore_replan_state_pb.LongRangeExploreReplanState.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.scan_planner.LongRangeExploreRequest}
 */
proto.scan_planner.LongRangeExploreRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.scan_planner.LongRangeExploreRequest;
  return proto.scan_planner.LongRangeExploreRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.scan_planner.LongRangeExploreRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.scan_planner.LongRangeExploreRequest}
 */
proto.scan_planner.LongRangeExploreRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readSint64());
      msg.setNumMeshPoints(value);
      break;
    case 2:
      var value = new pbtypes_gen_scan_output_scan_coverage_parameters_pb.ScanCoverageParameters;
      reader.readMessage(value,pbtypes_gen_scan_output_scan_coverage_parameters_pb.ScanCoverageParameters.deserializeBinaryFromReader);
      msg.setScanCoverageParameters(value);
      break;
    case 3:
      var value = new pbtypes_gen_scan_planner_long_range_explore_replan_state_pb.LongRangeExploreReplanState;
      reader.readMessage(value,pbtypes_gen_scan_planner_long_range_explore_replan_state_pb.LongRangeExploreReplanState.deserializeBinaryFromReader);
      msg.setReplanState(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.scan_planner.LongRangeExploreRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.scan_planner.LongRangeExploreRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.scan_planner.LongRangeExploreRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scan_planner.LongRangeExploreRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNumMeshPoints();
  if (f !== 0) {
    writer.writeSint64(
      1,
      f
    );
  }
  f = message.getScanCoverageParameters();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      pbtypes_gen_scan_output_scan_coverage_parameters_pb.ScanCoverageParameters.serializeBinaryToWriter
    );
  }
  f = message.getReplanState();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      pbtypes_gen_scan_planner_long_range_explore_replan_state_pb.LongRangeExploreReplanState.serializeBinaryToWriter
    );
  }
};


/**
 * optional sint64 num_mesh_points = 1;
 * @return {number}
 */
proto.scan_planner.LongRangeExploreRequest.prototype.getNumMeshPoints = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.scan_planner.LongRangeExploreRequest} returns this
 */
proto.scan_planner.LongRangeExploreRequest.prototype.setNumMeshPoints = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional scan_output.ScanCoverageParameters scan_coverage_parameters = 2;
 * @return {?proto.scan_output.ScanCoverageParameters}
 */
proto.scan_planner.LongRangeExploreRequest.prototype.getScanCoverageParameters = function() {
  return /** @type{?proto.scan_output.ScanCoverageParameters} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_scan_output_scan_coverage_parameters_pb.ScanCoverageParameters, 2));
};


/**
 * @param {?proto.scan_output.ScanCoverageParameters|undefined} value
 * @return {!proto.scan_planner.LongRangeExploreRequest} returns this
*/
proto.scan_planner.LongRangeExploreRequest.prototype.setScanCoverageParameters = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.scan_planner.LongRangeExploreRequest} returns this
 */
proto.scan_planner.LongRangeExploreRequest.prototype.clearScanCoverageParameters = function() {
  return this.setScanCoverageParameters(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.scan_planner.LongRangeExploreRequest.prototype.hasScanCoverageParameters = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional LongRangeExploreReplanState replan_state = 3;
 * @return {?proto.scan_planner.LongRangeExploreReplanState}
 */
proto.scan_planner.LongRangeExploreRequest.prototype.getReplanState = function() {
  return /** @type{?proto.scan_planner.LongRangeExploreReplanState} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_scan_planner_long_range_explore_replan_state_pb.LongRangeExploreReplanState, 3));
};


/**
 * @param {?proto.scan_planner.LongRangeExploreReplanState|undefined} value
 * @return {!proto.scan_planner.LongRangeExploreRequest} returns this
*/
proto.scan_planner.LongRangeExploreRequest.prototype.setReplanState = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.scan_planner.LongRangeExploreRequest} returns this
 */
proto.scan_planner.LongRangeExploreRequest.prototype.clearReplanState = function() {
  return this.setReplanState(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.scan_planner.LongRangeExploreRequest.prototype.hasReplanState = function() {
  return jspb.Message.getField(this, 3) != null;
};


goog.object.extend(exports, proto.scan_planner);
